import {FormGroupStore} from '@cycles/data-access';
import {CycleSignStore} from '@cycles/sign/data-access';
import {MetaTagsStore} from '@meta-tags/data-access';
import {FeatureStoreNames} from '@shared-types';
import {IFeatureStoresSchema} from '../types';
import formGroupInitialState = FormGroupStore.formGroupInitialState;
import metaTagsInitialState = MetaTagsStore.metaTagsInitialState;
import cycleSignInitialState = CycleSignStore.cycleSignInitialState;

export const featureStoresInitialState: IFeatureStoresSchema = {
	[FeatureStoreNames.CYCLE_SIGN_FEATURE_KEY]: cycleSignInitialState,
	[FeatureStoreNames.FORM_GROUP_FEATURE_KEY]: formGroupInitialState,
	[FeatureStoreNames.META_TAGS_FEATURE_KEY]: metaTagsInitialState,
};
